<aw-add-box-interface-to-box [box]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-add-box-interface-to-box>